export const PayByBankIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			width={24}
			height={24}
		>
			<path
				fill="#eff1fa"
				d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
			/>
			<path
				fill="currentColor"
				d="M12 6.5 6 9.5v1h12v-1zM7 12v5H6v1h12v-1h-1v-5h-1.5v5h-2v-5h-1.5v5h-2v-5z"
			/>
		</svg>
	);
};
